// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"776c05fb","715":"15013d3b"}[chunkId] + ".chunk.js";
};